import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Mixpanel } from '@/utils/mixpanel';
import Paper from '@mui/material/Paper';
import { Badge, Button, Typography } from '@mui/material';
import Link from 'next/link'
import { PRODUCT_CATEGORY_SPIRITS } from '@/consts/productConsts';
import { useRouter } from 'next/router';

const SearchTopicCard = ({item, url, narrow, highlight, disabled, onTopicClick}) => {
  const theme = useTheme();
  const router = useRouter();
  const height = '80px';
  const styles = {
    paperContainer: {
      backgroundImage: item?.cardImage && `url(${item.cardImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      height,
    },
  };
  
  
  const page = item.productCategory === PRODUCT_CATEGORY_SPIRITS ? 'spirits' : 'wines';
  const itemUrl = url || `${page}/?ref=card&topic=${item.queryParamKey}`;

  if (narrow) {
    let returnComp = (
      <Button
        variant="contained"
        sx={{
          borderRadius: '10px',
          whiteSpace: 'nowrap !important',
          display: 'inline-block',
          color: highlight && `${theme.palette.common.white} !important`,
          backgroundColor:
            highlight && `${theme.palette.primary.main} !important`,
        }}
        onClick={(e) => onTopicClick && onTopicClick(item)}
      >
        {item.cardText}
      </Button>
    );
    if (!onTopicClick) {
      returnComp = (
        <Link href={itemUrl}><a>{returnComp}</a></Link>
      )
    }
    return highlight ? (
      <Badge
        badgeContent={'X'}
        color="error"
        sx={{ cursor: 'pointer' }}
        onClick={() => onTopicClick(null)}
      >
        {returnComp}
      </Badge>
    ) : (
      returnComp
    );
  }

  const textComp = (
    <Box
      position="absolute"
      bottom="0"
      width={'100%'}
      height={'100%'}
      sx={{
        padding: '20px',
      }}
      zIndex={2}
      display="flex"
      alignItems="center"
    >
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontFamily: 'Recoleta',
          color: theme.palette.common.white,
          fontWeight: 500,
          textShadow: '1px 1spx 1px grey',
        }}
      >
        {item?.cardText}
      </Typography>
    </Box>
  )
  const bgComp = (
    <Box
      sx={{
        borderRadius: '20px',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: '100%',
        width: '100%',
        content: '" "',
        zIndex: 1,
        backgroundImage: item?.cardImage
          ? 'linear-gradient(to right, #04040487 40% ,  #7777776b 75%, #ffffff00)'
          : 'linear-gradient(to right, #6b3140 95%, #6b3140)',
      }}
    ></Box>
  )
  return (
    <Grid item>
      <Paper
        sx={{
          height,
          borderRadius: '20px',
          width: '40vw',
          minWidth: '150px',
          maxWidth: '200px',
          position: 'relative',
          border: highlight
            ? `4px solid ${theme.palette.primary.main}`
            : undefined,
          cursor: !disabled && 'pointer',
          transition: !disabled && 'all .2s ease-in-out',
          '&:hover': !disabled && {
            transform: `translateY(-${theme.spacing(1 / 2)})`,
          },
        }}
        style={styles.paperContainer}
        onClick={() => onTopicClick && onTopicClick(item)}
      >
        {itemUrl ? (
          <Link href={itemUrl}>
            <a>
              {bgComp}
              {textComp}
            </a>
          </Link>
        ) : (
          <>
            {bgComp}
            {textComp}
          </>
        )}
      </Paper>
    </Grid>
  )
};


SearchTopicCard.propTypes = {
  disabled: PropTypes.bool,
  narrow: PropTypes.bool,
  highlight: PropTypes.bool,
  item: PropTypes.object,
  url: PropTypes.string,
  onTopicClick: PropTypes.func
};

export default SearchTopicCard;
